import { render, staticRenderFns } from "./MainBackground.vue?vue&type=template&id=d13bdb02"
var script = {}
import style0 from "./MainBackground.vue?vue&type=style&index=0&id=d13bdb02&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports